// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82c0d168","239":"eb33c56e","455":"76b4d9fe"}[chunkId] + ".chunk.js";
};